import React, {Dispatch, FC, Fragment, SetStateAction, useState} from "react";
import cls from "./customSelect.module.scss";
import {DropDownArrow} from "../../../svg";
import useOutside from "../../../hooks/useOutside";
import {optionItemType} from "../../../types/homePageTypes";

interface ICustomSelect {
    selectArray: Array<optionItemType>;
    setOptionQuantity: Dispatch<SetStateAction<optionItemType[]>>
    optionQuantity: Array<optionItemType>
}

const CustomSelect:FC<ICustomSelect> = (
    {
        selectArray,
        setOptionQuantity,
        optionQuantity
    }
) => {
    const defaultValueExist =
        selectArray?.find((item) => !!item.is_default)
        || { name: "Select Option", id: 0, is_default: 1, bundleOptionId: 1, productQty: 1, optionDefaultQty: 1, price: 0 }
    const [open, setOpen] = useState<boolean>(false);
    const [selectVal, setSelectVal] = useState<optionItemType>(defaultValueExist);
    const { optionRef } = useOutside({ setOpen })
    const handleOptionClick = (value: optionItemType) => {
        setOpen(false);
        setSelectVal(value)
        const findOptQty = optionQuantity.find(({bundleOptionId}) => bundleOptionId === value.bundleOptionId);
        if (findOptQty) {
            setOptionQuantity(prevState => {
                const spliceThisItem = prevState
                    .filter(filteredElem => filteredElem.bundleOptionId !== findOptQty?.bundleOptionId)
                return [...spliceThisItem, value]
            })
        }
    }
    return (
        <div ref={optionRef} className={cls.main}>
            <div className={cls.select} onClick={() => setOpen((prevState) => !prevState)}>
                <p>{selectVal.name}</p>
                <DropDownArrow className={`${open ? cls.rotT_fms : ""}`}/>
            </div>
            {open ? (
                <div className={cls.optionBox}>
                    {selectArray.map((option) => {
                        return (
                            <div
                                key={option.id as number}
                                className={`${cls.select} ${cls.eachOption}`}
                                onClick={() => handleOptionClick(option)}
                            >
                                {option.name}
                            </div>
                        )
                    })}
                </div>
            ) : <Fragment />}
        </div>
    )
}

export default CustomSelect;
